var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function nonNull(val, fallback) {
    return Boolean(val) ? val : fallback;
}
export var DOMparseNode = function (element, properties, children) {
    var el = document.createElement(element);
    Object.keys(nonNull(properties, {})).forEach(function (key) {
        var dataPrefix = /^data/;
        if (dataPrefix.test(key)) {
            el.dataset[key.replace(dataPrefix, '').toLowerCase()] =
                properties[key];
        }
        else if (key.startsWith('on') && key.toLowerCase() in window) {
            // catches onClick etc..
            el.addEventListener(key.toLowerCase().substr(2), properties[key]);
        }
        else {
            el[key] = properties[key];
        }
    });
    if (children === null || children === void 0 ? void 0 : children.length) {
        children.forEach(function (child) {
            if (!child)
                return;
            if (Array.isArray(child)) {
                try {
                    child.forEach(function (c) { return el.appendChild(c); });
                }
                catch (err) {
                    console.error('C: ', child);
                    console.error(err);
                }
            }
            else {
                try {
                    el.append(child);
                }
                catch (err) {
                    console.error('CC: ', child, children);
                    console.error(err);
                }
            }
        });
    }
    return el;
};
export var DOMcreateElement = function (element, properties) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (typeof element === 'function') {
        return element(__assign(__assign({}, nonNull(properties, {})), { children: children }));
    }
    return DOMparseNode(element, properties, children);
};
export var DOMcreateFragment = function (props) {
    var el = new DocumentFragment();
    for (var _i = 0, _a = props.children; _i < _a.length; _i++) {
        var child = _a[_i];
        if (Array.isArray(child)) {
            for (var _b = 0, child_1 = child; _b < child_1.length; _b++) {
                var _child = child_1[_b];
                el.append(_child);
            }
        }
        else {
            el.append(child);
        }
    }
    return el;
};
